import { createPortal } from 'react-dom';

// Renders full-screen overlays directly under <body> so parent containers
// (overflow, contain, transform, tab bars) can never clip or offset them on mobile.
export default function BodyPortal({ children }) {
  if (typeof document === 'undefined') return children;
  return createPortal(children, document.body);
}
